import { Icon } from 'app/components/icon';
import { useI18n } from 'core/hooks/useI18n';
import { TagText, TagWrapper } from './ClassifiedByAiTag.styles';

export const ClassifiedByAiTag = () => {
  const { l10n } = useI18n('app/views/alerts', 'eventClassification');
  return (
    <>
      <TagWrapper>
        <Icon.Bot style={{ fill: 'none' }} width="24px" height="24px" />
        <TagText>
          {l10n('aiClassification.indicator')}
          <sup>TM</sup>
        </TagText>
      </TagWrapper>
    </>
  );
};
